import User, { GetUserSettings } from "app/models/user"

export enum Types {
  GET_CURRENT_USER = "CURRENT_USER_GET",
  GET_CURRENT_USER_SUCCESS = "CURRENT_USER_GET_SUCCESS",
  GET_CURRENT_USER_FAIL = "CURRENT_USER_GET_FAIL",
  PUT_USER_SETTINGS = "USER_SETTINGS_PUT",
  PUT_USER_SETTINGS_SUCCESS = "USER_SETTINGS_PUT_SUCCESS",
  PUT_USER_SETTINGS_FAIL = "USER_SETTINGS_PUT_FAIL",
}

export type Action =
  | GetCurrentUserAction
  | GetCurrentUserSuccessAction
  | GetCurrentUserFailAction
  | PutUserSettingsAction
  | PutUserSettingsSuccessAction
  | PutUserSettingsFailAction

export type GetCurrentUserAction = {
  type: Types.GET_CURRENT_USER
}

export type GetCurrentUserSuccessAction = {
  type: Types.GET_CURRENT_USER_SUCCESS
  payload: { data: User | undefined }
}

export type GetCurrentUserFailAction = {
  type: Types.GET_CURRENT_USER_FAIL
  payload: { errors: object }
}

export type PutUserSettingsAction = {
  type: Types.PUT_USER_SETTINGS
  payload: {
    data: GetUserSettings
  }
}

export type PutUserSettingsSuccessAction = {
  payload: { data: GetUserSettings }
  type: Types.PUT_USER_SETTINGS_SUCCESS
}

export type PutUserSettingsFailAction = {
  type: Types.PUT_USER_SETTINGS_FAIL
  payload: { errors: object }
}

export function getCurrentUser(): GetCurrentUserAction {
  return {
    type: Types.GET_CURRENT_USER,
  }
}

export function getCurrentUserSuccess(data: User | undefined): GetCurrentUserSuccessAction {
  return {
    payload: { data },
    type: Types.GET_CURRENT_USER_SUCCESS,
  }
}

export function getCurrentUserFail(errors: object): GetCurrentUserFailAction {
  return {
    payload: { errors },
    type: Types.GET_CURRENT_USER_FAIL,
  }
}

export function putUserSettings(payload: { data: GetUserSettings }): PutUserSettingsAction {
  return {
    payload,
    type: Types.PUT_USER_SETTINGS,
  }
}

export function putUserSettingsSuccess(data: GetUserSettings): PutUserSettingsSuccessAction {
  return {
    payload: { data },
    type: Types.PUT_USER_SETTINGS_SUCCESS,
  }
}

export function putUserSettingsFail(errors: object): PutUserSettingsFailAction {
  return {
    payload: { errors },
    type: Types.PUT_USER_SETTINGS_FAIL,
  }
}
